import { render, staticRenderFns } from "./TemplateRUS.vue?vue&type=template&id=331d844c&scoped=true&"
import script from "./TemplateRUS.vue?vue&type=script&lang=js&"
export * from "./TemplateRUS.vue?vue&type=script&lang=js&"
import style0 from "./TemplateRUS.vue?vue&type=style&index=0&id=331d844c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d844c",
  null
  
)

export default component.exports